import React, {useState, useEffect} from "react";
import {withTranslation} from "react-i18next";
import "../../ceiba.scss";
import {Button, Progress, Spin} from 'antd';
import {useDispatch} from "react-redux";
import {CheckCircleOutlined} from "@ant-design/icons";
import {history} from "../../../../../_helpers";
import {xcService} from "../../../../../_services/xcService";
import endpoint from "shared/endpoints";

function Nogam3Preview(props) {

    const {t} = props;
    useDispatch();
    const [answers, setAnswers] = useState([]);
    const [questions, setQuestions] = useState(-1);
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {
        const type = 'NOGAM6';
        try {
            let apiEndpoint = endpoint.studentAnswer.getAll(type);
            const responseA = await xcService.getToken(apiEndpoint);
             setAnswers(responseA.data.data)

            apiEndpoint = "/v1/student/assessments/"+type;
            const responseQ = await xcService.getToken(apiEndpoint);
            setQuestions(responseQ.data.data?.length)




            setLoading(false)

        } catch (e) {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData();


    }, []);


    const goTo = () => {
        if (questions === answers)
            history.push("/admin/end-nogam6")
        else
            history.push("/admin/nogam6")
    }

    return (


        <div className={"line"}>

            {!loading ?
                <>
                <p>{t('nogam6.previewLabel')}</p>
                <div className={"line-r"}>
                    { questions === answers.length ?
                      <div className={"posend"}>
                          <CheckCircleOutlined style={{ fontSize: 40}} />
                      </div> :
                      questions !== -1 ?
                        <div className={"posend"}>
                            <Progress width={38} type="circle" percent={ ((answers.length * 100) / (questions)) } format={() => ""} />
                        </div>
                        :
                        <div className={"posend"}></div>
                    }
                    <Button  onClick={() => goTo()}
                             type={"link"}
                             className="primaryButton btnWhiteBlue">
                        {t("enter")}
                    </Button>
                </div>
                </> : <Spin />}

        </div>
    )
}

export default withTranslation()(Nogam3Preview);
